import BagIcon from '../../../../../assets/svgs/Bag'
import ContactIcon from '../../../../../assets/svgs/ContactDB'
import CourseIcon from '../../../../../assets/svgs/CourseDB'
import EventIcon from '../../../../../assets/svgs/EventDB'
import Icon from '../../../../../assets/svgs/Icon'
import NewsIcon from '../../../../../assets/svgs/NewsDB'

import style from './style.module.css'

const ResponseFileIcon = ({ metadata }) => {
  const feedIcon = () => {
    switch (metadata.category) {
      case 'Jobs':
        return (
          <div
            className={style.iconContainer}
            style={{ background: '#A7CAFF' }}
          >
            <BagIcon />
          </div>
        )
      case 'Contacts':
        return (
          <div
            className={style.iconContainer}
            style={{ background: '#F79DFF' }}
          >
            <ContactIcon />
          </div>
        )
      case 'Chimp':
        return (
          <div
            className={style.iconContainer}
            style={{ background: '#432C5B' }}
          >
            <Icon />
          </div>
        )
      case 'Courses':
        return (
          <div
            className={style.iconContainer}
            style={{ background: '#FFC092' }}
          >
            <CourseIcon />
          </div>
        )
      case 'Events':
        return (
          <div
            className={style.iconContainer}
            style={{ background: '#78DEB9' }}
          >
            <EventIcon />
          </div>
        )
      case 'News':
        return (
          <div
            className={style.iconContainer}
            style={{ background: '#FF9191' }}
          >
            <NewsIcon />
          </div>
        )
      default:
        return null
    }
  }

  const handleClick = () => {
    window.open(metadata.url, '_blank')
  }

  return <div onClick={handleClick}>{feedIcon()}</div>
}

export default ResponseFileIcon
